
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const nav = document.querySelector('#MainNav');
  const toggle = document.querySelector('.mobile-toggle');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const openDrawer = () => {
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  };

  const closeDrawer = () => {
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  };

  document.querySelectorAll('[data-cart-close]').forEach(button => {
    button.addEventListener('click', closeDrawer);
  });

  function getActiveCurrency(cart) {
    const code =
      (cart && cart.currency) ||
      (window.WS && window.WS.localization && window.WS.localization.currency) ||
      'CAD';
    return /^[A-Z]{3}$/.test(code) ? code : 'CAD';
  }

  function formatMoney(cents, currencyCode) {
    const currency = /^[A-Z]{3}$/.test(currencyCode || '') ? currencyCode : getActiveCurrency();
    const amount = Number(cents || 0) / 100;
    try {
      return amount.toLocaleString(undefined, { style: 'currency', currency });
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, char => ({
      '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#039;'
    }[char]));
  }

  function refreshCart() {
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(response => {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });

    const items = document.querySelector('[data-cart-items]');
    if (items) {
      if (!cart.items.length) {
        items.innerHTML = '<p class="empty-cart">Your cart is empty.</p>';
      } else {
        items.innerHTML = cart.items.map(item => {
          const image = item.featured_image
            ? `<img src="${item.featured_image.url}" alt="${escapeHtml(item.product_title)}" width="80" height="80">`
            : '';
          return `<div class="cart-item"><div>${image}</div><div><strong>${escapeHtml(item.product_title)}</strong><p>${item.quantity} × ${formatMoney(item.final_line_price, cart.currency)}</p></div></div>`;
        }).join('');
      }
    }

    const total = document.querySelector('.cart-total strong');
    if (total) total.textContent = formatMoney(cart.total_price, cart.currency);
  }

  // Product variant selection: translate Size/Color/etc. into the correct Shopify variant ID.
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const variantsEl = form.parentElement.querySelector('[data-product-variants]');
    const idInput = form.querySelector('[data-variant-id]');
    const selects = [...form.querySelectorAll('[data-option-select]')];
    const error = form.querySelector('[data-variant-error]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const priceEl = form.parentElement.querySelector('[data-product-price]');

    if (!variantsEl || !idInput) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent.trim());
    } catch (e) {
      console.error('Wrenched Syndicate: could not read product variants.', e);
      return;
    }

    function selectedOptions() {
      return selects.map(select => select.value);
    }

    function findVariant() {
      const values = selectedOptions();
      return variants.find(variant =>
        variant.available &&
        variant.options.every((option, index) => option === values[index])
      ) || variants.find(variant =>
        variant.options.every((option, index) => option === values[index])
      );
    }

    function updateVariant() {
      const variant = findVariant();

      if (variant) {
        idInput.value = variant.id;

        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
        }

        if (error) error.hidden = true;
      } else {
        idInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'UNAVAILABLE';
        }
        if (error) error.hidden = false;
      }
    }

    selects.forEach(select => select.addEventListener('change', updateVariant));
    updateVariant();
  });

  // AJAX add-to-cart for both product forms and Quick Add buttons.
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();

      const id = form.querySelector('[name="id"]');
      if (!id || !id.value) {
        const error = form.querySelector('[data-variant-error]');
        if (error) error.hidden = false;
        return;
      }

      const button = form.querySelector('button[type="submit"], button');
      const originalText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'ADDING...';
      }

      try {
        const formData = new FormData(form);

        const addUrl = (form.dataset.cartAddUrl || ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add')) + '.js';

        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
          credentials: 'same-origin'
        });

        if (!response.ok) {
          let message = 'Unable to add this item to the cart.';
          try {
            const data = await response.json();
            if (data.description) message = data.description;
          } catch (_) {}
          throw new Error(message);
        }

        await response.json();
        const cart = await refreshCart();
        renderCart(cart);
        openDrawer();
      } catch (error) {
        console.error('Wrenched Syndicate cart:', error);
        alert(error.message || 'Unable to add this item to the cart.');
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    });
  });

  // Header cart opens the drawer.
  const cartLink = document.querySelector('.cart-link');
  if (cartLink && drawer) {
    cartLink.addEventListener('click', async event => {
      event.preventDefault();
      try {
        const cart = await refreshCart();
        renderCart(cart);
        openDrawer();
      } catch (_) {
        window.location.href = '/cart';
      }
    });
  }
});


  document.querySelectorAll('.quick-add').forEach(function(form) {
    const select = form.querySelector('.quick-add__select');
    const button = form.querySelector('.quick-add__button');
    if (!select || !button) return;

    select.addEventListener('change', function() {
      button.disabled = !select.value;
    });
  });


// Product image lightbox
(function() {
  const lightbox = document.querySelector('[data-image-lightbox]');
  const target = document.querySelector('[data-lightbox-target]');
  const closeButton = document.querySelector('[data-lightbox-close]');
  if (!lightbox || !target) return;

  const closeLightbox = function() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    target.removeAttribute('src');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('[data-lightbox-image]').forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      const img = link.querySelector('img');
      target.src = link.href;
      target.alt = img ? img.alt : '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });

  if (closeButton) closeButton.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function(event) {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
  });
})();


